// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const CopyIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="CopyIcon" ref={forwardedRef} {...props}>
      <path d="M4.01 2H12v1.499H4.514V12H3V3c0-.553.452-1 1.01-1" />
      <path d="M7 5a1 1 0 0 0-1 1v11a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm8.5 1.5v10h-8v-10z" />
    </SvgIcon>
  );
});

/**
 * Creates a copy of an item in a different location that you specify
 * @public
 */
export const CopyIcon = /* @__PURE__ */ Object.assign(CopyIconComponent, {
  displayName: 'CopyIcon',
});
